import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let client = null;
if (url && anonKey) {
  client = createClient(url, anonKey, {
    auth: { persistSession: false }   // anon write-only, no session needed
  });
} else if (typeof window !== 'undefined') {
  // Visible warning in the browser console only; do NOT throw, so the test still runs and displays results.
  console.warn(
    '[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is missing. ' +
    'Test results will not be persisted; the test itself will still run.'
  );
}

export const supabase = client;

/**
 * True when supabase is configured. False during local dev with no env vars and during unit tests.
 */
export function isSupabaseEnabled() {
  return supabase !== null;
}
